import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import Fade from "react-reveal"
// import { Button } from "baseui/button"
import { Block } from "baseui/block"
import { Cell } from "baseui/layout-grid"
import { Title, SubTitle, Description } from "../../components/typography"
import Container from "../../components/UI/Container"
import FlushedGrid from "../../components/FlushedGrid"

const WhatIsCrytoNewsAPI = () => {
  const Data = useStaticQuery(graphql`
    query {
      imgixImage(url: "/uploads/crypto-nlp-1.png") {
        fluid(maxWidth: 800) {
          ...GatsbyImgixFluid
        }
      }
    }
  `)

  return (
    <Block
      paddingTop={["50px", "100px"]}
      paddingBottom={["50px", "60px"]}
      id="control"
    >
      <Container>
        <FlushedGrid gridGutters={[0, 56]} gridGaps={24}>
          <Cell span={[12, 6]} align="center">
            <Block
              display="flex"
              alignItems="center"
              height={["400px", "100%"]}
              maxWidth="600px"
              marginLeft={["18px", "10%", "20%", 0]}
            >
              <Img
                fluid={{ ...Data.imgixImage.fluid }}
                style={{ width: "100%", height: "100%" }}
                imgStyle={{ objectFit: "contain" }}
                alt="Connections Image"
              />
            </Block>
          </Cell>
          <Cell span={[12, 6]} align="center">
            <Block
              display="flex"
              flexDirection="column"
              marginLeft={["18px", "10%", "20%", 0]}
            >
              <SubTitle>What is Crypto News API?</SubTitle>
              <Title>Monitor Crypto News and Risks Easily</Title>
              <Fade up>
                <span>
                  <Description paddingBottom="20px">
                    Crypto News API automatically scrapes news sources and
                    generates risk scorings using a sentiment analysis model
                    trained on crypto news sources, allowing you to easily track
                    crypto news and risks.
                  </Description>
                </span>
              </Fade>
            </Block>
          </Cell>
        </FlushedGrid>
      </Container>
    </Block>
  )
}

export default WhatIsCrytoNewsAPI
